import {
  FormatAlignCenter as CenterAlign,
  FormatAlignJustify as JustifyAlign,
  FormatAlignLeft as LeftAlign,
  FormatAlignRight as RightAlign
} from '@mui/icons-material';
import { useCommands } from '@remirror/react-core';

import '../../styles.css';

export const Alignment = () => {
  const { centerAlign, justifyAlign, leftAlign, rightAlign } = useCommands();

  return (
    <>
      <button
        onClick={() => centerAlign()}
        className={
          !centerAlign?.active?.() &&
          !rightAlign?.active?.() &&
          !justifyAlign?.active?.()
            ? ''
            : 'hidden'
        }
        type="button"
      >
        <LeftAlign />
      </button>
      <button
        onClick={() => rightAlign()}
        className={centerAlign.active?.() ? '' : 'hidden'}
        type="button"
      >
        <CenterAlign />
      </button>
      <button
        onClick={() => justifyAlign()}
        className={rightAlign.active?.() ? '' : 'hidden'}
        type="button"
      >
        <RightAlign />
      </button>
      <button
        onClick={() => leftAlign()}
        className={justifyAlign.active?.() ? '' : 'hidden'}
        type="button"
      >
        <JustifyAlign />
      </button>
    </>
  );
};
